module.exports = __webpack_public_path__ + "static/media/video.16c250a7.svg";